export default __webpack_public_path__ + "static/media/ls committee.5296c83c.png";